import * as React from 'react';

import { cn } from '@dashboard/lib/utils';

type StepDotsProps = React.ComponentProps<'div'> & {
  total: number;
  current: number;
  maxClickable?: number;
  onNavigate?: (index: number) => void;
};

function StepDots({
  total,
  current,
  maxClickable,
  onNavigate,
  className,
  ...props
}: StepDotsProps) {
  const effectiveMaxClickable = maxClickable ?? total;

  return (
    <div
      data-slot="step-dots"
      className={cn('flex items-center justify-center gap-2', className)}
      {...props}
    >
      {Array.from({ length: total }, (_, i) => {
        const isCurrent = i === current;
        const isClickable = i < effectiveMaxClickable;

        return (
          <button
            key={i}
            type="button"
            data-slot="step-dot"
            data-state={isCurrent ? 'active' : 'inactive'}
            disabled={!isClickable}
            aria-label={`Go to step ${i + 1}`}
            aria-current={isCurrent ? 'step' : undefined}
            onClick={() => isClickable && onNavigate?.(i)}
            className={cn(
              'h-2 rounded-full outline-none transition-all duration-300 ease-[cubic-bezier(0.16,1,0.3,1)] focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
              isCurrent
                ? 'w-6 bg-foreground cursor-default'
                : isClickable
                  ? 'w-2 bg-border hover:bg-muted-foreground/50 cursor-pointer'
                  : 'w-2 bg-border cursor-default',
            )}
          />
        );
      })}
    </div>
  );
}

export { StepDots };
